import React, { Component } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import AddNew from './AddNew';
import Card from './Card';
import Dialog from './Dialog';

class Tree extends Component {
  constructor (props) {
    super(props);
    let data = null;
    try {
      data = JSON.parse(props.data);
    } catch (e) {
      data = [];
    }
    this.state = {
      data,
      currentData: {},
      error: false,
    };
  }

  componentDidUpdate (preProps) {
    let data = null;
    if ((this.props.data !== this.state.data) && (this.props.data !== preProps.data)) {
      try {
        data = JSON.parse(this.props.data);
      } catch (e) {
        data = [];
      }
      this.setState({ data });
    }
  }

  save=() => this.props.onChange(this.state.data)

  returnError=({ name = '', item = '' }) => {
    const { data } = this.state;

    const returnObject = (ary = [], func = () => {}) => {
      for (const o of ary) {
        if (o.name === item) return o;
        else if ((o.ary || []).length > 0 && func(o.ary, func)) {
          return func(o.ary, func);
        }
      }
    };
    const itemObject = returnObject(data, returnObject);

    const returnE = (ary = [], func = () => {}) => {
      let error = false;
      for (const o of ary) {
        if (o.name === name)error = true;
        else if ((o.ary || []).length > 0 && func(o.ary, func)) {
          error = true;
        }
      }
      return error;
    };
    return returnE(itemObject.ary, returnE);
  }

  handleDrag=({ name = '', item = '' }) => {
    const { data } = this.state;

    let itemObject = {};
    const returnObject = (ary = [], func = () => {}) => {
      for (let i = 0; i < ary.length; i++) {
        const o = ary[i];
        if (o.name === item) {
          itemObject = JSON.parse(JSON.stringify(o));
          ary.splice(i, 1);
          // itemObject = oldAry[i];
        } else if ((o.ary || []).length > 0) {
          func(o.ary, func);
        }
      }
    };
    returnObject(data, returnObject);

    const moveData = (ary = [], func = () => {}) => {
      if (name) {
        for (const o of ary) {
          if (o.name === name)o.ary.push(itemObject);
          else if ((o.ary || []).length > 0) {
            func(o.ary, func);
          }
        }
      } else data.push(itemObject);
    };
    moveData(data, moveData);
    this.setState({ data: [...data] }, this.save);
  }

  openDialog=(data = {}) => {
    this.setState({ currentData: JSON.parse(JSON.stringify(data)) });
  }

  closeDialog=() => this.setState({ currentData: {}, error: false }, this.save)

  returenDailogNameReError=({ newName = '', oldName = '' }) => {
    const { data } = this.state;
    let error = false;
    const returnObject = (ary = [], func = () => {}) => {
      for (let i = 0; i < ary.length; i++) {
        const o = ary[i];
        if (o.name === newName && (oldName.length === 0 || !(oldName === o.name))) {
          error = true;
        }
        if ((o.ary || []).length > 0) {
          func(o.ary, func);
        }
      }
    };
    returnObject(data, returnObject);
    return error;
  }

  onDialogDelete=() => {
    const { data, currentData = {} } = this.state;
    const { name = '' } = currentData;
    const returnObject = (ary = [], func = () => {}) => {
      for (let i = 0; i < ary.length; i++) {
        const o = ary[i];
        if (o.name === name) {
          ary.splice(i, 1);
        } else if ((o.ary || []).length > 0) {
          func(o.ary, func);
        }
      }
    };
    returnObject(data, returnObject);
    this.setState({ data: [...data] }, this.closeDialog);
  }

  onDialogEdit=body => {
    const { data, currentData = {} } = this.state;
    const { name = '' } = currentData;
    if (!this.returenDailogNameReError({ newName: body.name, oldName: name })) {
      const returnObject = (ary = [], func = () => {}) => {
        for (let i = 0; i < ary.length; i++) {
          const o = ary[i];
          if (o.name === name) {
            ary.splice(i, 1, body);
          } else if ((o.ary || []).length > 0) {
            func(o.ary, func);
          }
        }
      };
      returnObject(data, returnObject);
      this.setState({ data: [...data] }, this.closeDialog);
    } else this.setState({ error: true });
  }

  onDialogAdd=body => {
    const { data, currentData = {} } = this.state;
    const { name } = currentData;
    if (!this.returenDailogNameReError({ newName: body.name })) {
      if (name) {
        const returnObject = (ary = [], func = () => {}) => {
          for (let i = 0; i < ary.length; i++) {
            const o = ary[i];
            if (o.name === name) {
              o.ary = o.ary || [];
              o.ary.push({
                name: body.name || '',
                data1: body.data1 || '',
                ary: [],
              });
            } else if ((o.ary || []).length > 0) {
              func(o.ary, func);
            }
          }
        };
        returnObject(data, returnObject);
      } else {
        data.push({
          name: body.name || '',
          data1: body.data1 || '',
          ary: [],
        });
      };
      this.setState({ data: [...data] }, this.closeDialog);
    } else this.setState({ error: true });
  }

  render () {
    const { data, currentData, error } = this.state;
    const { disabled } = this.props;
    return (
      <div style={{ margin: 8, backgroundColor: 'white', borderRadius: 8 }}>
        <DndProvider backend={HTML5Backend}>
          <div style={{ padding: 12, display: 'flex', flexDirection: 'column-reverse', alignItems: 'center' }}>
            <AddNew onClick={() => this.openDialog({ name: null })} handleDrag={this.handleDrag} disabled={disabled} />
            {data.length > 0 && <div style={{ width: 2, height: 10, backgroundColor: 'black' }} />}
            <Card ary={data} Item={Card} returnError={this.returnError} handleDrag={this.handleDrag} onClick={this.openDialog} disabled={disabled} />
          </div>
        </DndProvider>
        {Object.keys(currentData).length > 0 && (
          <Dialog
            onClose={this.closeDialog}
            currentData={currentData}
            onDelete={this.onDialogDelete}
            onEdit={this.onDialogEdit}
            onAdd={this.onDialogAdd}
            error={error}
          />
        )}
      </div>
    );
  }
}

export default Tree;
